// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PopupVideo.css */
.popup-container {
  text-align: center;
  margin-top: 20px;
}

.popup {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: auto;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: #fff;
  padding: 15px;
  border-radius: 18px;
  text-align: center;
  position: relative;
}

.close {
  position: absolute;
  top: 1px;
  right: 4px;
  font-size: 24px;
  cursor: pointer;
  color: #ff0000;
  background: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/css/PopupVideo.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["/* PopupVideo.css */\r\n.popup-container {\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.popup {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  width: auto;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.popup-content {\r\n  background-color: #fff;\r\n  padding: 15px;\r\n  border-radius: 18px;\r\n  text-align: center;\r\n  position: relative;\r\n}\r\n\r\n.close {\r\n  position: absolute;\r\n  top: 1px;\r\n  right: 4px;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  color: #ff0000;\r\n  background: #fff;\r\n  border-radius: 50%;\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
